export default __webpack_public_path__ + "static/icon-0d4e75db38539772d2a66355cdc5a2bf.png";